export const PROSPECT = 'prospect';
export const ACTIVE = 'active';
export const NOT_INTERESTED = 'notInterested';
export const CHURNED = 'churned';
export const REMOVED = 'removed';
export const OUT_OF_TARGET = 'outOfTarget';
export const UNRESPONSIVE = 'unresponsive';
export const ON_HOLD = 'onHold';

export const StatusSuccess = 'success';
export const StatusWarning = 'warning';
export const StatusError = 'error';
export const StatusInfo = 'info';
export const StatusComplete = 'complete';
export const StatusDisabled = 'disabled';
